import { css } from 'styled-components';
import { FontWeight, FONT_NAME } from './constants';

const variants = [
  [FontWeight.REGULAR, 'font/MessinaSansWeb-400.woff'],
  [FontWeight.SEMI_BOLD, 'font/MessinaSansWeb-600.woff'],
  [FontWeight.BOLD, 'font/MessinaSansWeb-700.woff'],
] as const;

const staticFile = (path: string) => `/static/unicron/${path}`;

export const FontDefinition = css`
  ${variants.map(
    ([weight, path]) => css`
      @font-face {
        font-family: ${FONT_NAME};
        font-weight: ${weight};
        font-display: swap;
        font-style: normal;
        font-stretch: normal;
        unicode-range: U+000D-FB04;
        src: url(${staticFile(path)}) format('woff');
      }
    `,
  )}
`;
